import * as firestore from 'firebase/firestore';
import { DateTime } from 'luxon';
import { RequestStatus } from '../types/Type';
import { Vacation, VacationStatus } from '../types/Vacation';

export default {
  toFirestore(vacation: Vacation): firestore.DocumentData {
    return vacation;
  },
  fromFirestore(
    snapshot: firestore.QueryDocumentSnapshot
  ): Vacation {
    const data = snapshot.data()!;
    return {
      id: data.id,
      idNumber: data.idNumber,
      name: data.name,
      status: data.status as VacationStatus,
      requestDateStart: data.requestDateStart,
      requestDateEnd: data.requestDateEnd,
      dateStart: data.dateStart,
      dateEnd: data.dateEnd,
      dateRequested: data.dateRequested,
      requestStatus: data.requestStatus as RequestStatus,
      lastUpdate: typeof(data.lastUpdate) === 'string' ? data.lastUpdate : DateTime.fromJSDate((data.lastUpdate as firestore.Timestamp).toDate()).toISO(),
      files: data.files,
    };
  }
};
